"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.knowledgeRoutes = void 0;
const knowledgeActions_openapi_1 = require("./knowledgeActions.openapi");
exports.knowledgeRoutes = {
    knowledge: [
        // Knowledge routes
        {
            name: 'knowledge.list',
            path: ['/', '/q/:q'],
            method: 'GET',
            plugins: {
                openapi: knowledgeActions_openapi_1.knowledgeOpenApiDocs['knowledge.list']
            }
        },
        {
            name: 'knowledge.create',
            path: ['/'],
            method: 'POST',
            plugins: {
                openapi: knowledgeActions_openapi_1.knowledgeOpenApiDocs['knowledge.create']
            }
        },
        {
            name: 'knowledge.bulk-upload',
            path: ['/bulk-upload'],
            method: 'POST',
            plugins: {
                openapi: knowledgeActions_openapi_1.knowledgeOpenApiDocs['knowledge.bulk-upload']
            }
        },
        {
            name: 'knowledge.google-drive-directory-upload',
            path: ['/google-drive-directory-upload'],
            method: 'POST',
            plugins: {
                openapi: knowledgeActions_openapi_1.knowledgeOpenApiDocs['knowledge.google-drive-directory-upload']
            }
        },
        {
            name: 'knowledge.get',
            path: '/:id',
            method: 'GET',
            plugins: {
                openapi: knowledgeActions_openapi_1.knowledgeOpenApiDocs['knowledge.get']
            }
        },
        {
            name: 'knowledge.update',
            path: '/:id',
            method: 'PUT',
            plugins: {
                openapi: knowledgeActions_openapi_1.knowledgeOpenApiDocs['knowledge.update']
            }
        },
        {
            name: 'knowledge.reindex',
            path: '/:id/reindex',
            method: 'GET',
            plugins: {
                openapi: knowledgeActions_openapi_1.knowledgeOpenApiDocs['knowledge.reindex']
            }
        },
        {
            name: 'knowledge.delete',
            path: '/:id',
            method: 'DELETE',
            plugins: {
                openapi: knowledgeActions_openapi_1.knowledgeOpenApiDocs['knowledge.delete']
            }
        }
    ],
    project: [
        {
            name: 'project.list',
            path: ['/', '/q/:q'],
            method: 'GET'
        },
        {
            name: 'project.create',
            path: ['/'],
            method: 'POST'
        },
        {
            name: 'project.get',
            path: '/:id',
            method: 'GET'
        },
        {
            name: 'project.update',
            path: '/:id',
            method: 'PUT'
        },
        {
            name: 'project.delete',
            path: '/:id',
            method: 'DELETE'
        }
    ]
};
